import { t } from "../i18n";
import type { SupportedModel } from "../models/supported";

export function ModelsTable({ models }: { models: readonly SupportedModel[] }) {
  return (
    <section aria-labelledby="models-h">
      <h3 id="models-h">{t("models.heading")}</h3>
      <p class="notice warn">{t("models.purchase_spec")}</p>
      <table>
        <thead>
          <tr>
            <th scope="col">{t("models.col.model")}</th>
            <th scope="col">{t("models.col.codename")}</th>
            <th scope="col">{t("models.col.tier")}</th>
            <th scope="col">{t("models.col.updates")}</th>
            <th scope="col">{t("models.col.status")}</th>
          </tr>
        </thead>
        <tbody>
          {models.map((m) => (
            <tr key={m.id}>
              <td>{m.name}</td>
              <td><code>{m.codename}</code></td>
              <td>{t(`models.tier.${m.tier}`)}</td>
              <td>{m.google_updates_until}</td>
              <td>{m.active ? t("models.active") : t("models.inactive")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
